import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

/**
 * 顧客の編集・削除ボタンを表示するコンポーネント
 */
const ActionButtons = ({ onEdit, onDelete }) => {
  return (
    <Box display="flex" gap={1}>
      <Tooltip title="顧客を編集">
        <IconButton 
          color="primary" 
          onClick={onEdit}
          sx={{ bgcolor: 'rgba(25, 118, 210, 0.08)' }}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="顧客を削除">
        <IconButton 
          color="error" 
          onClick={onDelete}
          sx={{ bgcolor: 'rgba(211, 47, 47, 0.08)' }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ActionButtons;